(function () {
  var config = window.TravelAvenuePostHog || {};
  var queue = [];
  var initialized = false;
  var initStarted = false;
  var predictiveSearchQueries = {};
  var highIntentTimer = null;
  var collectionScrollMarks = {};
  var pageScrollMarks = {};
  var pageLeaveCaptured = false;
  var recommendationImpressions = {};
  var recommendationObserver = null;
  var consentStartAttempts = 0;
  var analyticsIdentityCookie = "ta_analytics_id";
  var authenticationStateCookie = "ta_authentication_state";
  var analyticsIdentity = "";
  var featureFlagKeys = [
    "ta_promo_banner_experiment",
    "ta_chat_visibility",
    "ta_product_page_experiment",
    "travel-avenue-promo-banner-experiment"
  ];

  if (!config.enabled || !config.token || !config.apiHost) {
    window.TravelAvenueAnalytics = {
      capture: function () {}
    };
    return;
  }

  function compact(value) {
    var output = {};
    Object.keys(value || {}).forEach(function (key) {
      var item = value[key];
      if (item === "" || item === null || typeof item === "undefined") return;
      output[key] = item;
    });
    return output;
  }

  function numberValue(value) {
    if (typeof value === "number") return value;
    if (typeof value !== "string") return undefined;
    var parsed = Number(value.replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  function readCookie(name) {
    var prefix = name + "=";
    var cookies = String(document.cookie || "").split(";");
    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) return decodeURIComponent(cookie.slice(prefix.length));
    }
    return "";
  }

  function validAnalyticsIdentity(value) {
    return /^ta_[a-f0-9-]{20,80}$/i.test(String(value || ""));
  }

  function createAnalyticsIdentity() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return "ta_" + window.crypto.randomUUID();
    }
    var values = new Uint32Array(4);
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      window.crypto.getRandomValues(values);
      return "ta_" + Array.prototype.map.call(values, function (value) {
        return value.toString(16).padStart(8, "0");
      }).join("");
    }
    return "";
  }

  function ensureAnalyticsIdentity() {
    if (validAnalyticsIdentity(analyticsIdentity)) return analyticsIdentity;
    var existing = readCookie(analyticsIdentityCookie);
    analyticsIdentity = validAnalyticsIdentity(existing) ? existing : createAnalyticsIdentity();
    if (analyticsIdentity) {
      document.cookie = analyticsIdentityCookie + "=" + encodeURIComponent(analyticsIdentity) + "; Path=/; Max-Age=31536000; SameSite=Lax; Secure";
      document.cookie = authenticationStateCookie + "=" + authenticationState() + "; Path=/; Max-Age=31536000; SameSite=Lax; Secure";
    }
    return analyticsIdentity;
  }

  function authenticationState() {
    return config.authenticationState === "logged_in" ? "logged_in" : "guest";
  }

  function pageProperties() {
    return compact({
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: config.pageType,
      currency: config.currency
    });
  }

  function productProperties(prefix, source) {
    source = source || {};
    var props = {};
    props[(prefix || "product") + "_id"] = source.productId || source.product_id || config.productId;
    props[(prefix || "product") + "_handle"] = source.productHandle || source.handle || config.productHandle;
    props[(prefix || "product") + "_title"] = source.productTitle || source.product_title || source.title || config.productTitle;
    props[(prefix || "product") + "_vendor"] = source.productVendor || source.vendor || config.productVendor;
    props.variant_id = source.variantId || source.variant_id || source.id || config.variantId;
    props.price = numberValue(source.price || source.final_price || source.presentment_price || config.productPrice);
    return compact(props);
  }

  function safeSearchTerm(value) {
    if (!value) return "";
    var term = String(value).trim().slice(0, 80);
    if (term.indexOf("@") !== -1 || /\d{6,}/.test(term)) {
      return "[redacted]";
    }
    return term;
  }

  function sanitizeText(value, maxLength) {
    if (!value) return "";
    var text = String(value).replace(/\s+/g, " ").trim().slice(0, maxLength || 160);
    if (text.indexOf("@") !== -1 || /\b(?:\+?\d[\d\s().-]{6,})\b/.test(text)) {
      return "[redacted]";
    }
    return text;
  }

  function sanitizeUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(String(value), window.location.origin);
      return url.origin === window.location.origin ? url.pathname : url.origin;
    } catch (error) {
      return "";
    }
  }

  function safeErrorProperties(error, extra) {
    var props = compact(Object.assign({
      error_name: error && error.name ? sanitizeText(error.name, 80) : "Error",
      error_message: error && error.message ? sanitizeText(error.message, 220) : sanitizeText(error, 220),
      error_source: extra && extra.source ? sanitizeUrl(extra.source) : "",
      error_line: extra && extra.line,
      error_column: extra && extra.column,
      reason_type: extra && extra.reasonType,
      posthog_surface: "shopify_storefront"
    }, extra && extra.properties ? extra.properties : {}));
    delete props.source;
    return props;
  }

  /* PostHog carries the project API key in properties.token and its own metadata in
     $-prefixed keys. Redacting those by name silently kills ingestion: a redacted token
     leaves PostHog unable to resolve the project, so it drops the event outright. Keep
     identity keys verbatim and give $-keys a light pass instead of the name blocklist. */
  var posthogIdentityKeys = ["token", "distinct_id", "uuid", "api_key"];

  function sanitizeReservedText(value) {
    var text = String(value).slice(0, 500);
    return text.indexOf("@") !== -1 ? "[redacted]" : text;
  }

  function sanitizePostHogProperties(properties) {
    var blocked = /(?:email|phone|address|message|password|token|secret|name|first_name|last_name)/i;
    Object.keys(properties || {}).forEach(function (key) {
      if (posthogIdentityKeys.indexOf(key) !== -1) return;
      var isReservedExceptionField = key.indexOf("$exception_") === 0 || key === "error_message" || key === "error_name";
      if (isReservedExceptionField && typeof properties[key] === "string") {
        properties[key] = sanitizeText(properties[key], 500);
      } else if (key.charAt(0) === "$") {
        if (typeof properties[key] === "string") {
          properties[key] = sanitizeReservedText(properties[key]);
        }
      } else if (blocked.test(key)) {
        properties[key] = "[redacted]";
      } else if (typeof properties[key] === "string") {
        properties[key] = sanitizeText(properties[key], 220);
      }
    });
    return properties;
  }

  function capture(name, properties, options) {
    var payload = compact(Object.assign({}, pageProperties(), properties || {}, {
      analytics_correlation_id: analyticsIdentity,
      authentication_state: authenticationState()
    }));

    if (!initialized || !window.posthog || typeof window.posthog.capture !== "function") {
      if (config.requireShopifyConsent && !initStarted) return;
      queue.push([name, payload, options]);
      return;
    }

    try {
      window.posthog.capture(name, payload, options);
    } catch (error) {}
  }

  function flushQueue() {
    var events = queue.splice(0, queue.length);
    events.forEach(function (event) {
      capture(event[0], event[1], event[2]);
    });
  }

  function installPostHogSnippet() {
    /* PostHog's recommended browser snippet, loaded only after Shopify analytics consent is allowed. */
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

    analyticsIdentity = ensureAnalyticsIdentity();
    window.posthog.init(config.token, {
      api_host: config.apiHost,
      defaults: "2026-01-30",
      autocapture: !!config.autocaptureEnabled,
      capture_exceptions: !!config.errorTrackingEnabled,
      capture_pageview: true,
      capture_pageleave: true,
      enable_heatmaps: true,
      opt_in_site_apps: true,
      disable_session_recording: !config.sessionReplayEnabled,
      mask_all_element_attributes: true,
      logs: {
        serviceName: "travelavenue-shopify-theme",
        environment: "production",
        serviceVersion: "posthog-web-2026-06-04"
      },
      advanced_feature_flags_dedup_per_session: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: "*",
        blockSelector: "[data-ph-no-capture], .shopify-payment-button, .payment-icons, iframe",
        maskTextFn: function () {
          return "";
        }
      },
      before_send: function (event) {
        if (event && event.properties) {
          sanitizePostHogProperties(event.properties);
        }
        return event;
      },
      loaded: function (posthog) {
        initialized = true;
        if (typeof posthog.register === "function") {
          posthog.register({ authentication_state: authenticationState() });
        }
        if (analyticsIdentity && typeof posthog.identify === "function") {
          posthog.identify(analyticsIdentity);
        }
        if (config.identifyLoggedInCustomer && config.customerId && typeof posthog.identify === "function") {
          posthog.identify(config.customerId);
        }
        bindFeatureFlags(posthog);
        flushQueue();
        capturePostHogSetupLog(posthog);
        captureInitialEvents();
        captureUrlGatedTestException();
      }
    });
  }

  function capturePostHogSetupLog(posthog) {
    if (!posthog || !posthog.logger || typeof posthog.logger.info !== "function") return;
    try {
      posthog.logger.info("travelavenue posthog storefront initialized", {
        page_type: config.pageType || "unknown",
        analytics_surface: "shopify_storefront",
        heatmaps_enabled: true,
        session_replay_enabled: !!config.sessionReplayEnabled,
        autocapture_enabled: !!config.autocaptureEnabled
      });
    } catch (error) {}
  }

  function captureException(error, extra) {
    if (!config.errorTrackingEnabled) return;
    var props = safeErrorProperties(error, extra || {});
    if (initialized && window.posthog && typeof window.posthog.captureException === "function") {
      try {
        window.posthog.captureException(error || props.error_message || "Unknown error", props);
        return;
      } catch (captureError) {}
    }
    capture("frontend exception", props);
  }

  function captureUrlGatedTestException() {
    if (!config.errorTrackingEnabled) return;
    try {
      var params = new URLSearchParams(window.location.search || "");
      if (params.get("ta_posthog_error_test") !== "codex") return;
      var storageKey = "ta_posthog_error_test_captured";
      var storageValue = window.location.pathname + window.location.search;
      if (window.sessionStorage && window.sessionStorage.getItem(storageKey) === storageValue) return;
      if (window.sessionStorage) {
        window.sessionStorage.setItem(storageKey, storageValue);
      }
      capture("posthog error test requested", {
        test_mode: true,
        test_source: "codex_posthog_setup",
        posthog_surface: "shopify_storefront"
      });
      captureException(new Error("TravelAvenue PostHog test exception"), {
        properties: {
          test_mode: true,
          test_source: "codex_posthog_setup",
          posthog_surface: "shopify_storefront"
        }
      });
    } catch (error) {}
  }

  function analyticsAllowed() {
    if (!config.requireShopifyConsent) return true;
    if (!window.Shopify || !window.Shopify.customerPrivacy) return false;
    if (typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function") {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    }
    if (typeof window.Shopify.customerPrivacy.userCanBeTracked === "function") {
      return window.Shopify.customerPrivacy.userCanBeTracked();
    }
    return false;
  }

  function startPostHog() {
    if (initStarted || !analyticsAllowed()) return;
    initStarted = true;
    installPostHogSnippet();
  }

  function loadCustomerPrivacyThenStart() {
    if (!config.requireShopifyConsent) {
      startPostHog();
      return;
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      startPostHog();
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function () {
          startPostHog();
        }
      );
      return;
    }

    if (consentStartAttempts < 40) {
      consentStartAttempts += 1;
      window.setTimeout(loadCustomerPrivacyThenStart, 250);
    }
  }

  function captureInitialEvents() {
    if (config.pageType === "product") {
      capture("product viewed", productProperties("product"));
      if (!highIntentTimer) {
        highIntentTimer = window.setTimeout(function () {
          capture("high intent product view", Object.assign({ engagement_seconds: 60 }, productProperties("product")));
        }, 60000);
      }
    }

    if (config.pageType === "cart") {
    }

    if (config.pageType === "collection") {
      if (numberValue(config.collectionProductsCount) === 0) {
        capture("collection empty viewed", collectionProperties());
      }
    }

    if (config.pageType === "search") {
      var searchProps = searchProperties();
      capture("search results viewed", searchProps);
      if (numberValue(config.searchResultsCount) === 0) {
        capture("search zero results viewed", searchProps);
      }
    }
  }

  function collectionProperties(extra) {
    return compact(Object.assign({
      collection_title: config.collectionTitle,
      collection_handle: config.collectionHandle,
      collection_products_count: numberValue(config.collectionProductsCount),
      collection_all_products_count: numberValue(config.collectionAllProductsCount),
      collection_sort_by: config.collectionSortBy
    }, extra || {}));
  }

  function searchProperties(extra) {
    return compact(Object.assign({
      search_term: safeSearchTerm(config.searchTerm),
      search_results_count: numberValue(config.searchResultsCount),
      query_length: config.searchTerm ? String(config.searchTerm).length : 0
    }, extra || {}));
  }

  function productLinkPosition(link) {
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]'));
    return links.indexOf(link) + 1;
  }

  function recommendationContext(element) {
    if (!element || !element.closest) return null;
    var list = element.closest("[data-ta-dynamic-recommendations]");
    if (!list) return null;
    var cartRoot = list.closest("[data-ta-cart-recommendations]");
    var cartContext = cartRoot && cartRoot.getAttribute("context");
    var mode = list.dataset.taRecommendationMode || "pdp";
    return {
      list: list,
      surface: cartContext === "wishlist" ? "wishlist_cross_sell" : cartContext === "cart" ? "cart_cross_sell" : "pdp_related",
      algorithm: mode === "accessory" ? "accessory_cross_sell_v1" : mode === "school" ? "school_round_robin_v1" : "travel_allocation_v1"
    };
  }

  function recommendationProperties(card, context) {
    var cards = Array.prototype.filter.call(
      context.list.querySelectorAll("[data-ta-product-card]"),
      function (candidate) { return !candidate.hidden && candidate.getAttribute("aria-hidden") !== "true"; }
    );
    return compact(Object.assign({}, productProperties("product", {
      productId: card.dataset.taProductId,
      productHandle: card.dataset.taProductHandle,
      productTitle: card.dataset.taProductTitle,
      productVendor: card.dataset.taProductVendor,
      price: numberValue(card.dataset.taProductPriceCents) / 100
    }), {
      recommendation_surface: context.surface,
      recommendation_algorithm: context.algorithm,
      recommendation_position: cards.indexOf(card) + 1,
      recommendation_score: numberValue(card.dataset.taRecommendationScore),
      recommendation_reason: card.dataset.taRecommendationReason || "catalog_order",
      recommendation_exploration: card.dataset.taRecommendationExploration === "true",
      recommendation_exploration_policy: card.dataset.taRecommendationExplorationPolicy || undefined,
      recommendation_source_rank: numberValue(card.dataset.taRecommendationSourceRank),
      source_product_handle: config.productHandle || ""
    }));
  }

  function observeRecommendationCards(scope) {
    if (!("IntersectionObserver" in window)) return;
    if (!recommendationObserver) {
      recommendationObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var card = entry.target;
          var context = recommendationContext(card);
          if (!context) return;
          var key = context.surface + ":" + (card.dataset.taProductId || card.dataset.taProductHandle || "");
          if (!key || recommendationImpressions[key]) return;
          recommendationImpressions[key] = true;
          capture("recommendation product viewed", recommendationProperties(card, context));
          recommendationObserver.unobserve(card);
        });
      }, { threshold: 0.5 });
    }
    var root = scope || document;
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ta-dynamic-recommendations] [data-ta-product-card]"));
    if (root.matches && root.matches("[data-ta-dynamic-recommendations] [data-ta-product-card]")) cards.push(root);
    cards.forEach(function (card) {
      if (card.dataset.taRecommendationObserved === "true") return;
      card.dataset.taRecommendationObserved = "true";
      recommendationObserver.observe(card);
    });
  }

  function applyPromoBannerExperiment(variant) {
    var el = document.querySelector("[data-ta-promo-banner]");
    if (!el) return;
    var next = variant === "test" ? el.getAttribute("data-ta-promo-test") : el.getAttribute("data-ta-promo-control");
    if (!next) return;
    if (el.textContent !== next) el.textContent = next;
  }

  function bindFeatureFlags(posthog) {
    if (!posthog || typeof posthog.onFeatureFlags !== "function") return;
    posthog.onFeatureFlags(function () {
      featureFlagKeys.forEach(function (key) {
        var value = typeof posthog.getFeatureFlag === "function" ? posthog.getFeatureFlag(key) : undefined;
        if (value === undefined || value === null) return;
        var attr = "data-" + key.replace(/_/g, "-");
        document.documentElement.setAttribute(attr, String(value));
        if (key === "travel-avenue-promo-banner-experiment") {
          applyPromoBannerExperiment(String(value));
        }
        capture("feature flag evaluated", {
          flag_key: key,
          flag_value: String(value).slice(0, 80)
        });
      });
    });
  }

  function captureCollectionScroll() {
    if (config.pageType !== "collection") return;
    var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    var percent = Math.round((window.scrollY / scrollable) * 100);
    [50, 90].forEach(function (mark) {
      if (percent >= mark && !collectionScrollMarks[mark]) {
        collectionScrollMarks[mark] = true;
        capture("collection scrolled", collectionProperties({ scroll_depth_percent: mark }));
      }
    });
  }

  function currentScrollPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollHeight = Math.max(
      doc ? doc.scrollHeight : 0,
      body ? body.scrollHeight : 0
    );
    var viewportHeight = window.innerHeight || (doc && doc.clientHeight) || 0;
    var scrollable = Math.max(1, scrollHeight - viewportHeight);
    var scrollTop = window.pageYOffset || (doc && doc.scrollTop) || (body && body.scrollTop) || 0;
    return Math.max(0, Math.min(100, Math.round((scrollTop / scrollable) * 100)));
  }

  function capturePageScroll() {
    var percent = currentScrollPercent();
    [25, 50, 75, 90].forEach(function (mark) {
      if (percent >= mark && !pageScrollMarks[mark]) {
        pageScrollMarks[mark] = true;
        capture("$scroll", {
          scroll_depth_percent: mark,
          scroll_percent: percent,
          posthog_surface: "shopify_storefront"
        });
      }
    });
  }

  function capturePageLeave() {
    if (pageLeaveCaptured) return;
    pageLeaveCaptured = true;
    capture("$pageleave", {
      scroll_depth_percent: currentScrollPercent(),
      posthog_surface: "shopify_storefront"
    }, {
      send_instantly: true,
      transport: "sendBeacon"
    });
  }

  function formType(form) {
    if (!form || !form.dataset) return "website_form";
    return form.dataset.taCrmFormType || form.getAttribute("data-ta-crm-form-type") || "website_form";
  }

  function formIntent(form) {
    if (!form || !form.dataset) return "";
    return form.dataset.taCrmIntent || form.getAttribute("data-ta-crm-intent") || "";
  }

  function formSource(form) {
    if (!form || !form.dataset) return "shopify_theme";
    return form.dataset.taCrmSource || form.getAttribute("data-ta-crm-source") || "shopify_theme";
  }

  function isCrmForm(form) {
    return !!(form && form.matches && (form.matches("[data-ta-crm-form]") || form.querySelector('[name^="contact["], [name^="customer["]')));
  }

  function itemFromCartEvent(event) {
    var detail = event.detail || {};
    var items = detail.items || [];
    var item = items[0] || {};
    return compact(Object.assign(
      {
        quantity: numberValue(item.quantity),
        cart_item_count: detail.cart && detail.cart.item_count
      },
      productProperties("product", item)
    ));
  }

  function nearestProductText(element) {
    var card = element && element.closest && element.closest(".product-card, .ta-product-card, .ta-collection-card, form");
    var title = card && card.querySelector && card.querySelector(".product-card__title, .ta-card-title, [data-product-title], h2, h3");
    return title ? title.textContent.trim().slice(0, 120) : "";
  }

  function searchSource(formOrElement) {
    if (!formOrElement || !formOrElement.closest) return "search";
    if (formOrElement.closest("header-search, .header-search, predictive-search, .predictive-search")) return "predictive_search";
    if (formOrElement.closest(".main-search-form")) return "main_search";
    return "search";
  }

  function safeChatEventName(value) {
    var name = String(value || "");
    return /^ta_chat_[a-z0-9_]+$/.test(name) ? name : "";
  }

  function chatAnalyticsProperties(detail) {
    var properties = Object.assign({}, detail && detail.properties ? detail.properties : {});
    delete properties.message;
    delete properties.reply;
    delete properties.email;
    delete properties.phone;
    delete properties.name;
    delete properties.order_number;
    return compact(Object.assign({
      source: "chatkit",
      posthog_surface: "shopify_storefront"
    }, properties));
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      var megaMenuLink = event.target.closest && event.target.closest("[data-ta-mega-menu-link]");
      if (megaMenuLink) {
        capture("mega menu link clicked", compact({
          menu: megaMenuLink.dataset.taMenu,
          menu_column: megaMenuLink.dataset.taMenuColumn,
          link_label: megaMenuLink.dataset.taMenuLabel,
          destination_type: megaMenuLink.dataset.taDestinationType,
          destination_path: megaMenuLink.pathname || "",
          locale: document.documentElement.lang || ""
        }));
      }

      var addButton = event.target.closest && event.target.closest("[data-ta-add-to-cart], .product-card__quick-add-button");
      if (addButton) {
        var discoveryCard = addButton.closest("[data-ta-discovery-retrieval-source]");
        capture("product quick add clicked", compact({
          source: "product_card",
          product_title: nearestProductText(addButton),
          variant_id: addButton.form && addButton.form.querySelector('[name="id"]') ? addButton.form.querySelector('[name="id"]').value : "",
          discovery_retrieval_source: discoveryCard && discoveryCard.dataset.taDiscoveryRetrievalSource,
          discovery_trace_id: discoveryCard && discoveryCard.dataset.taDiscoveryTraceId
        }));
      }

      var recommendationCard = event.target.closest && event.target.closest("[data-ta-dynamic-recommendations] [data-ta-product-card]");
      if (recommendationCard) {
        var recommendation = recommendationContext(recommendationCard);
        var recommendationLink = event.target.closest('a[href*="/products/"]');
        if (recommendation && recommendationLink) {
          var recommendationProps = recommendationProperties(recommendationCard, recommendation);
          capture("recommendation product clicked", recommendationProps);
          try {
            window.sessionStorage.setItem("ta:recommendation-attribution:v1", JSON.stringify({
              product_path: recommendationLink.pathname,
              properties: recommendationProps,
              expires_at: Date.now() + 30 * 60 * 1000
            }));
          } catch (error) {
          }
        }
      }

      var resultLink = event.target.closest && event.target.closest("predictive-search a, .predictive-search a, .search-results a, [data-ta-search-results] a");
      if (resultLink) {
        var discoveryResult = resultLink.closest("[data-ta-discovery-retrieval-source]");
        if (discoveryResult && resultLink.pathname) {
          try {
            window.sessionStorage.setItem("ta:discovery-attribution:v1", JSON.stringify({
              product_path: resultLink.pathname,
              retrieval_source: discoveryResult.dataset.taDiscoveryRetrievalSource || "",
              trace_id: discoveryResult.dataset.taDiscoveryTraceId || "",
              expires_at: Date.now() + 30 * 60 * 1000
            }));
          } catch (error) {
          }
        }
        capture("search result clicked", compact({
          source: searchSource(resultLink),
          result_path: resultLink.pathname || "",
          result_text: resultLink.textContent.trim().slice(0, 120),
          discovery_retrieval_source: discoveryResult && discoveryResult.dataset.taDiscoveryRetrievalSource,
          discovery_trace_id: discoveryResult && discoveryResult.dataset.taDiscoveryTraceId
        }));
      }

      if ((config.pageType === "collection" || config.pageType === "search") && event.target.closest) {
        var productLink = event.target.closest('a[href*="/products/"]');
        if (productLink) {
          capture(config.pageType === "collection" ? "collection product clicked" : "search product clicked", compact(Object.assign({
            product_position: productLinkPosition(productLink),
            product_path: productLink.pathname || "",
            product_title: nearestProductText(productLink)
          }, config.pageType === "collection" ? collectionProperties() : searchProperties())));
        }
      }
    }, true);

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;

      if (form.getAttribute("action") && form.getAttribute("action").indexOf("/search") !== -1) {
        var searchInput = form.querySelector('[name="q"]');
      }

      if (isCrmForm(form)) {
        var props = compact({
          source: formSource(form),
          form_type: formType(form),
          intent: formIntent(form)
        });
        capture("crm form submitted", props);
        if (props.form_type === "chatkit_support_handoff" || props.source === "chatkit") {
          capture("chat handoff submitted", props);
        }
      }
    }, true);

    document.addEventListener("input", function (event) {
      var input = event.target;
      if (!input || input.name !== "q" || !input.closest || !input.closest("predictive-search, header-search, .predictive-search, .header-search")) return;
      var term = safeSearchTerm(input.value);
      if (term.length < 3 || predictiveSearchQueries[term]) return;
      predictiveSearchQueries[term] = true;
      window.setTimeout(function () {
        capture("predictive search viewed", compact({
          source: "predictive_search",
          search_term: term,
          query_length: input.value ? input.value.length : 0
        }));
      }, 500);
    }, true);

    document.addEventListener("change", function (event) {
      var field = event.target;
      if (!field || !field.name) return;
      var isSort = field.name === "sort_by" || field.name.indexOf("sort") !== -1;
      var isFilter = field.name.indexOf("filter.") === 0 || field.closest && field.closest("facet-filters-form, .facets, [data-filter-form]");
      if (!isSort && !isFilter) return;

      capture(isSort ? "product sort changed" : "product filter changed", compact(Object.assign({
        control_name: field.name,
        control_value: field.value,
        checked: typeof field.checked === "boolean" ? field.checked : undefined
      }, collectionProperties())));
    }, true);

    var scrollFrameId = null;
    window.addEventListener("scroll", function () {
      if (scrollFrameId !== null) return;
      scrollFrameId = window.requestAnimationFrame(function () {
        scrollFrameId = null;
        capturePageScroll();
        captureCollectionScroll();
      });
    }, { passive: true });

    window.addEventListener("pagehide", capturePageLeave);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        capturePageLeave();
      }
    });

    document.addEventListener("variant:add", function (event) {
      var recommendationCard = event.target && event.target.closest && event.target.closest("[data-ta-dynamic-recommendations] [data-ta-product-card]");
      var recommendation = recommendationContext(recommendationCard);
      if (recommendationCard && recommendation) {
        capture("recommendation add to cart", recommendationProperties(recommendationCard, recommendation), { send_instantly: true, transport: "sendBeacon" });
      }
      try {
        var recommendationAttribution = JSON.parse(window.sessionStorage.getItem("ta:recommendation-attribution:v1") || "null");
        if (
          !recommendationCard &&
          recommendationAttribution &&
          Number(recommendationAttribution.expires_at) >= Date.now() &&
          recommendationAttribution.product_path === window.location.pathname
        ) {
          capture("recommendation add to cart", recommendationAttribution.properties || {}, { send_instantly: true, transport: "sendBeacon" });
          window.sessionStorage.removeItem("ta:recommendation-attribution:v1");
        }
        var attribution = JSON.parse(window.sessionStorage.getItem("ta:discovery-attribution:v1") || "null");
        if (
          attribution &&
          Number(attribution.expires_at) >= Date.now() &&
          attribution.product_path === window.location.pathname
        ) {
          capture("discovery product added to cart", compact({
            discovery_retrieval_source: attribution.retrieval_source,
            discovery_trace_id: attribution.trace_id,
            product_path: attribution.product_path
          }), { send_instantly: true, transport: "sendBeacon" });
          window.sessionStorage.removeItem("ta:discovery-attribution:v1");
        }
      } catch (error) {
      }
    }, true);

    document.addEventListener("dialog:before-show", function (event) {
      if (event.target && event.target.matches && event.target.matches("cart-drawer, #cart-drawer")) {
        capture("cart drawer opened");
      }
    }, true);

    document.addEventListener("travelavenue:chat-opened", function () {
      capture("chat opened", { source: "chatkit" });
      capture("ta_chat_opened", { source: "chatkit" });
    });

    document.addEventListener("travelavenue:chat-session-requested", function (event) {
      capture("chat session requested", compact({
        source: "chatkit",
        page_path: event.detail && event.detail.page
      }));
    });

    document.addEventListener("travelavenue:chat-analytics", function (event) {
      var name = safeChatEventName(event.detail && event.detail.event_name);
      if (!name) return;
      capture(name, chatAnalyticsProperties(event.detail));
    });

    document.addEventListener("travelavenue:discovery-applied", function (event) {
      var detail = event.detail || {};
      capture("discovery results applied", compact({
        search_term: safeSearchTerm(detail.query),
        query_length: detail.query ? String(detail.query).length : 0,
        discovery_version: detail.version,
        discovery_trace_id: detail.trace_id,
        parser: detail.parser,
        candidate_count: numberValue(String(detail.candidate_count || 0)),
        eligible_count: numberValue(String(detail.eligible_count || 0)),
        retrieval_source: detail.retrieval_source,
        vector_candidate_count: numberValue(String(detail.vector_candidate_count || 0)),
        model_route_decision: detail.model_route_decision,
        model_route_reason: detail.model_route_reason,
        model_assist_attempted: Boolean(detail.model_assist_attempted),
        model_assist_applied: Boolean(detail.model_assist_applied),
        model_assist_latency_ms: numberValue(String(detail.model_assist_latency_ms || 0)),
        model_assist_actual_cost_usd: Number(detail.model_assist_actual_cost_usd || 0),
        model_assist_projected_cost_usd: Number(detail.model_assist_projected_cost_usd || 0)
      }));
    });
  }

  window.TravelAvenueAnalytics = {
    capture: capture,
    captureException: captureException,
    getFeatureFlag: function (key) {
      if (!initialized || !window.posthog || typeof window.posthog.getFeatureFlag !== "function") return undefined;
      return window.posthog.getFeatureFlag(key);
    }
  };

  document.addEventListener("visitorConsentCollected", function () {
    startPostHog();
  });
  document.addEventListener("trackingConsentAccepted", function () {
    startPostHog();
  });
  window.addEventListener("load", function () {
    loadCustomerPrivacyThenStart();
  });

  bindEvents();
  observeRecommendationCards(document);
  if ("MutationObserver" in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.querySelectorAll) observeRecommendationCards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  loadCustomerPrivacyThenStart();
})();
